const MAX_FILE_NAME_LENGTH = 34;
const FRONT_CHARS_LENGTH = 10;
const BACK_CHARS_LENGTH = MAX_FILE_NAME_LENGTH - FRONT_CHARS_LENGTH - 3;

export default class FileItemModel {
  static getNameWithExtension(url: string): string {
    const nameDecoded = decodeURIComponent(url.split('/')[1]);
    return nameDecoded;
  }

  static truncateFileName(fileName: string): string {
    if (!fileName) return '';
    if (fileName.length <= MAX_FILE_NAME_LENGTH) return fileName;
    return `${fileName.slice(0, FRONT_CHARS_LENGTH)}...${fileName.slice(fileName.length - BACK_CHARS_LENGTH)}`;
  }
}
